// extracted by mini-css-extract-plugin
export default {"csNotice":"CustomerServiceNotice_csNotice__M+HWJ","btnMore":"CustomerServiceNotice_btnMore__zbpA9"};